import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import { checkRequired } from "pages/formTools";
import { Account } from "../..";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

export const validateName = (data: Account): FieldErrorMap => ({
  firstName: checkRequired(ta("fields.first_name"), data.firstName),
  lastName: checkRequired(ta("fields.last_name"), data.lastName),
});
